import { styled } from "@mui/material";
import { cloneElement, isValidElement } from "react";
import { ToastContainer } from "react-toastify";
import type { IconProps } from "react-toastify";
import sbComponents from "../../styles/sbDesignSystem/sbComponents";
import { SB_FONTS } from "../../styles/sbDesignSystem/sbTypography";

const ToastStyled1 = styled(ToastContainer)(({ theme }) => ({
  zIndex: theme.zIndex.toast,
  "& .Toastify__toast--success": {
    background: theme.palette.accentSuccess10.main,
    boxShadow: theme.mixins.shadowAccentSuccess20,
  },
  "& .Toastify__toast--warning": {
    background: theme.palette.accentWarning10.main,
    boxShadow: theme.mixins.shadowAccentWarning20,
  },
  "& .Toastify__toast--info": {
    background: theme.palette.accentInfo10.main,
    boxShadow: theme.mixins.shadowAccentInfo20,
  },
  "& .Toastify__toast--error": {
    background: theme.palette.accentDanger10.main,
    boxShadow: theme.mixins.shadowAccentDanger20,
  },
  "& .Toastify__toast": {
    color: theme.palette.text50.main,
    height: "10px",
    fontFamily: SB_FONTS["body"],
    width: "fit-content",
    maxWidth: "700px",
  },
  "& .Toastify__close-button": {
    width: "20px",
    height: "20px",
  },
  fontSize: "16px",
}));

const getIcon = ({ type }: IconProps) => {
  const defaultIcon = <span />;
  if (!sbComponents?.MuiAlert?.defaultProps?.iconMapping) return defaultIcon;
  const { iconMapping } = sbComponents.MuiAlert.defaultProps;
  const icon = type === "default" ? undefined : iconMapping[type];

  return cloneElement(isValidElement(icon) ? icon : defaultIcon, {
    width: "18px",
    height: "18px",
  });
};

const ToastStyled = () => {
  return <ToastStyled1 hideProgressBar position="bottom-right" closeButton={false} icon={getIcon} />;
};

export { ToastStyled };
